import { FaWhatsapp } from "react-icons/fa";
import { buildWhatsAppUrl } from "../../lib/constants";
import { trackEvent } from "../../lib/api";

export default function FloatingWhatsApp() {
  return (
    <a
      href={buildWhatsAppUrl("Hola, vengo del sitio web y me interesa cotizar una velaria")}
      target="_blank"
      rel="noopener noreferrer"
      role="button"
      tabIndex={0}
      onClick={() => trackEvent("cta_whatsapp_click", { location: "floating" })}
      aria-label="Contactar por WhatsApp"
      className="group fixed z-50 bottom-24 right-4 sm:bottom-6 sm:right-6 inline-flex items-center"
      data-testid="floating-whatsapp"
    >
      {/* Tooltip (desktop hover) */}
      <span
        className="hidden md:inline-flex mr-3 items-center px-3 py-2 bg-eclipse-900 border border-[#25D366]/50 text-white text-[12px] font-mono uppercase tracking-widest whitespace-nowrap opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-lg"
        data-testid="floating-whatsapp-tooltip"
      >
        Chatea con nosotros →
      </span>

      {/* Button */}
      <span
        className="relative w-14 h-14 md:w-[60px] md:h-[60px] rounded-full grid place-items-center transition-all duration-300 vt-wa-pulse group-hover:scale-105"
        style={{
          background: "#25D366",
          boxShadow: "0 8px 24px rgba(37, 211, 102, 0.35)",
        }}
      >
        {/* Expanding ring */}
        <span
          className="absolute inset-0 rounded-full vt-wa-ring pointer-events-none"
          style={{ border: "2px solid rgba(37, 211, 102, 0.5)" }}
        />
        <FaWhatsapp size={28} color="#ffffff" />
      </span>

      <style>{`
        @keyframes vt-wa-pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }
        @keyframes vt-wa-ring {
          0% { transform: scale(1); opacity: 0.7; }
          100% { transform: scale(1.7); opacity: 0; }
        }
        .vt-wa-pulse { animation: vt-wa-pulse 4s ease-in-out infinite; }
        .vt-wa-pulse:hover { background: #1DA851 !important; }
        .vt-wa-ring { animation: vt-wa-ring 2.4s ease-out infinite; }
      `}</style>
    </a>
  );
}
